module.exports = __webpack_public_path__ + "1793882494189/fonts/WorkSans-Medium.d8f4a3a.woff2";